import configs from "./api.json";

const apiFun = (() => {
  // 获取当前环境
  let env = "prod"; // 默认生产环境

  // 根据域名判断环境
  let hostname = window.location.hostname;
  if (
    hostname.indexOf("localhost") > -1 ||
    hostname.indexOf("127.0.0.1") > -1 ||
    hostname.indexOf("192.168") > -1
  ) {
    env = "dev";
  } else if (hostname.indexOf("test") > -1) {
    env = "test";
  }

  return env;
})();

const apiUrl = configs[apiFun];

const env = process?.env || {};

export const name = env.REACT_APP_NAME;
export const version = env.REACT_APP_VERSION;

export const dev = apiFun.startsWith("dev");
export const test = apiFun.startsWith("test");
export const prod =
  apiFun.startsWith("pro") && !location.host.startsWith("test");

export const url = apiUrl.REACT_APP_URL || "https://app-api.bestgame99.com/v3";
export const sysUrl = apiUrl.REACT_APP_SYS_URL || "https://sys.9917.cn";
export const ocpcUrl = apiUrl.REACT_APP_OCPC_URL || "https://tgm.9917.cn";
export const localUrl =
  apiUrl.REACT_APP_LOCAL_URL || "https://resource.sxay.net";
export const activityUrl =
  apiUrl.REACT_APP_ACTIVITY_URL || "https://activity.bestgame99.com";
export const boxNewUrl =
  apiUrl.REACT_APP_NEW_URL || "https://app-api.bestgame99.com/v4";
